var map = {
	"./BUSANPA/admin/index/DocumentMgr": [
		2612,
		20,
		553,
		755
	],
	"./DEMO/admin/index/DocumentMgr": [
		6066,
		20,
		553,
		934
	],
	"./POSTECH/admin/index/DocumentMgr": [
		4762,
		20,
		553,
		116
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9298;
module.exports = webpackAsyncContext;